<template>
  <el-row
    :gutter="20"
    v-if="getProfileList.length > 1">
    <el-col
      :sm="8"
      :xs="24">
      <div class="order-profile-selector">
        <div
          class="order-profile-selector_selected-item"
          @click="toggle()">
          <div class="order-profile-selector_selected-item-name">
            {{ getSelectedItem.name }}
          </div>
          <div class="order-profile-selector_selected-item-icon">

          </div>
        </div>
        <div
          class="order-profile-selector_unselected-list"
          :class="{open: isOpen}">
          <div
            class="order-profile-selector_unselected-item"
            v-for="item in getUnselectedList"
            :key="item.id"
            @click="onSelect(item.id)">
            {{ item.name }}
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  import filter from 'lodash/filter'
  import find from 'lodash/find'

  export default {
    name: 'ProfileList',
    data: function () {
      return {
        isOpen: false
      }
    },
    mounted: function () {
      window.$(document).on('click', e => {
        if (window.$(e.target).parents('.order-profile-selector').length === 0) {
          this.close()
        }
      })
    },
    computed: {
      ...mapGetters('order', [
        'getProfileList'
      ]),
      getSelectedItem: function () {
        return find(this.getProfileList, 'selected')
      },
      getUnselectedList: function () {
        return filter(this.getProfileList, {selected: false})
      }
    },
    methods: {
      ...mapActions('order', [
        'setProfileById'
      ]),
      ...mapMutations('order', [
        'setProfileNew'
      ]),
      open: function () {
        this.isOpen = true
      },
      close: function () {
        this.isOpen = false
      },
      toggle: function () {
        this.isOpen = !this.isOpen
      },
      onSelect: function (id) {
        if (id !== 0) {
          this.setProfileById(id)
        } else {
          this.setProfileNew()
        }
        this.close()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Order/ProfileList.vue